import React from "react";
import icon1 from "./../../../images/workicons/1.png";
import icon2 from "./../../../images/workicons/2.png";
import icon3 from "./../../../images/workicons/3.png";
import icon4 from "./../../../images/workicons/4.png";

const features = [
  {
    icon: "https://dashboard.codeparrot.ai/api/image/Z65C_o9nxTWt8izE/vuesax-b.png",
    background: icon1,
    title: "Easy Integration For Developers",
    description:
      "Our robust APIs make it simple for developers to add translation, text-to-speech, and speech-to-text features into their apps and platforms. This empowers businesses and innovators to create inclusive, language-aware products",
  },
  {
    icon: "https://dashboard.codeparrot.ai/api/image/Z65C_o9nxTWt8izE/vuesax-b-2.png",
    background: icon2,
    title: "Accurate And Culturally Sensitive Translations",
    description:
      "Our AI-powered tools understand the nuances of African languages, delivering translations that respect cultural and tonal context. This ensures communication is not only accurate but also meaningful.",
  },
  {
    icon: "https://dashboard.codeparrot.ai/api/image/Z65C_o9nxTWt8izE/vuesax-b-3.png",
    background: icon3,
    title: "Supporting Text And Speech",
    description:
      "NKENNEAi provides translation services for both written and spoken language. Whether you need to translate documents, websites, or conversations, our technology ensures seamless communication.",
  },
  {
    icon: "https://dashboard.codeparrot.ai/api/image/Z65C_o9nxTWt8izE/vuesax-b-4.png",
    background: icon4,
    title: "Connecting Communities Globally",
    description:
      "By removing language barriers, we enable Africans to share their stories, products, and ideas with the world. Our mission is to ensure African voices are heard on a global scale, fostering deeper connections and understanding",
  },
];

const FeatureSection = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-16 w-full max-w-[1071px] mx-auto p-8 lg:mt-0 mt-8">
      {features.map((feature, index) => (
        <div key={index} className="flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <div className="flex flex-row items-center gap-7 justify-center">
              <div className="relative">
                <img
                  src={feature.background}
                  alt=""
                  className="w-20 h-20 bg-secondary rounded-full"
                />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <h3 className="text-[22px] font-black text-center font-['Axiforma']">
                {feature.title}
              </h3>
              <p className="text-base text-center  leading-normal">
                {feature.description}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeatureSection;
